import React from "react";
import { RoleAddContextProvider } from "./AddRoleView";
import RoleAdd from "./views/AddRoles";

const AddRolePage = () => {
  return (
    <div>
      <RoleAddContextProvider>
        <RoleAdd />
      </RoleAddContextProvider>
    </div>
  );
};

export default AddRolePage;
